﻿(function () {
    "use strict";

    // enables min & max validation on <input type="text" /> elements via attributes, which is not supported by built-in min & max directives

    let app = angular.module("app");

    app.directive("max", maxNumDirective);

    maxNumDirective.$inject = ["$parse"];

    function maxNumDirective($parse) {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                var maxVal = attr.max || $parse(attr.ngMax)(scope);

                var parsedMaxVal = parseNumValue(maxVal);

                ctrl.$validators.max = function (modelValue, viewValue) {
                    return isNaN(parsedMaxVal) || modelValue === null || modelValue <= parsedMaxVal;
                };

                attr.$observe('max', function (val) {
                    if (val !== maxVal) {
                        parsedMaxVal = parseNumValue(val);
                        maxVal = val;
                        ctrl.$validate();
                    }
                });
            }
        };
    }

    app.directive("min", minNumDirective);

    minNumDirective.$inject = ["$parse"];

    function minNumDirective($parse) {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                var minVal = attr.min || $parse(attr.ngMin)(scope);

                var parsedMinVal = parseNumValue(minVal);

                ctrl.$validators.min = function (modelValue, viewValue) {
                    return isNaN(parsedMinVal) || modelValue === null || modelValue >= parsedMinVal;
                };

                attr.$observe('min', function (val) {
                    if (val !== minVal) {
                        parsedMinVal = parseNumValue(val);
                        minVal = val;
                        ctrl.$validate();
                    }
                });
            }
        }
    };

    function parseNumValue(value) {
        if (typeof value === "undefined" || value === null || isNaN(value))
            return NaN;

        return parseFloat(value);
    };


})();